(() => {
  // app/scripts/page-brands.js
  var brandsFilter = document.querySelector("#brands_filter");
  var charlist = brandsFilter.querySelectorAll('.charlist input[type="checkbox"]');
  var charatersGroup = document.querySelectorAll(".charaters-group");
  var elmShowing = brandsFilter.querySelector(".brands-showing");
  var elmUpdateShowing = elmShowing.querySelector(".jsUpdateShowing");
  var numberAllBrands = elmShowing.dataset.all;
  var btnAllBrands = document.querySelector(".jsAllBrands");
  charlist.forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      const value = checkbox.value;
      const idGroup = `charaters_group_${value}`;
      const listSize = document.querySelectorAll(`#${idGroup} .item`).length;
      if (checkbox.checked) {
        elmUpdateShowing.textContent = listSize;
        checkbox.classList.add("checked");
        charlist.forEach((otherCheckbox) => {
          if (otherCheckbox !== checkbox) {
            otherCheckbox.checked = false;
            otherCheckbox.classList.remove("checked");
          }
        });
        charatersGroup.forEach((item) => {
          item.classList.toggle("hidden", item.id.split("_")[2] !== value);
        });
      } else {
        elmUpdateShowing.textContent = numberAllBrands;
        checkbox.classList.remove("checked");
        charatersGroup.forEach((item) => item.classList.remove("hidden"));
      }
    });
  });
  btnAllBrands.addEventListener("click", () => {
    const allVendor = document.querySelectorAll(".charaters-content .item-vendor-name");
    allVendor.forEach((vendor) => vendor.style.display = "block");
    const arrSearchInput = document.querySelectorAll(".search_input");
    arrSearchInput.forEach((searchInput) => searchInput.value = "");
    charlist.forEach((checkbox) => {
      checkbox.checked = false;
      checkbox.classList.remove("checked");
    });
    elmUpdateShowing.textContent = numberAllBrands;
    charatersGroup.forEach((item) => item.classList.remove("hidden"));
  });
  function sidebarBrandFilter(container) {
    function updateSelected(searchInput2) {
      const allVendor = container.querySelectorAll(".charaters-content .item-vendor-name");
      allVendor.forEach((vendor) => {
        vendor.style.display = searchInput2 && !vendor.dataset.vendorName.includes(searchInput2) ? "none" : "block";
      });
    }
    function searchInput() {
      const arrSearchInput = container.querySelectorAll(".search_input");
      arrSearchInput.forEach((searchInput2) => {
        searchInput2.addEventListener("input", (e) => {
          e.preventDefault();
          const inputValue = searchInput2.value;
          updateSelected(inputValue);
        });
      });
    }
    searchInput();
  }
  sidebarBrandFilter(document);
})();
